
export default function SuitableFor() {
  const suitable = [
    {
      icon: 'ri-flashlight-line',
      title: '今すぐカードが必要な方',
      description: '最短5分でカード番号発行。急な買い物や旅行予約にすぐ対応できます。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '旅行保険を重視する方',
      description: '国内・海外旅行保険が最高3,000万円。一般カードでは最高クラスの補償内容です。',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'スマホ保険が欲しい方',
      description: 'スマートフォン保険付帯。画面割れなどの修理費用を年間最高3万円まで補償。',
    },
    {
      icon: 'ri-cup-line',
      title: 'スターバックスをよく利用する方',
      description: 'スタバでポイント20倍！コーヒー好きには見逃せない特典です。',
    },
    {
      icon: 'ri-shopping-bag-line',
      title: 'Amazonでよく買い物する方',
      description: 'Amazonでポイント4倍。ネットショッピングでお得にポイントが貯まります。',
    },
    {
      icon: 'ri-plane-line',
      title: '出張や旅行が多い方',
      description: '充実の旅行保険で国内・海外の出張や旅行も安心してお出かけできます。',
    },
  ];

  const notSuitable = [
    {
      icon: 'ri-money-yen-circle-line',
      text: '年会費無料にこだわる方（条件付き無料のため）',
    },
    {
      icon: 'ri-percent-line',
      text: '高還元率を求める方（通常還元率0.5%）',
    },
    {
      icon: 'ri-global-line',
      text: '海外利用がメインの方（一部地域で使えない店舗もあり）',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-3 text-center">
          地方銀行系スピード発行カードが向いている人
        </h2>
        <p className="text-gray-600 text-center mb-12">あなたに合っているか確認しましょう</p>

        <div className="mb-12">
          <div className="bg-gradient-to-r from-[#E8F5E9] to-[#F8F9FA] rounded-xl p-6 mb-6">
            <h3 className="text-xl font-bold text-[#003366] mb-6 flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-[#4CAF50] text-2xl"></i>
              こんな方におすすめ
            </h3>
            <div className="grid md:grid-cols-2 gap-4">
              {suitable.map((item, index) => (
                <div key={index} className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-[#4CAF50] rounded-full flex-shrink-0">
                      <i className={`${item.icon} text-white text-lg`}></i>
                    </div>
                    <div>
                      <h4 className="text-[#003366] font-bold text-sm mb-1">{item.title}</h4>
                      <p className="text-gray-600 text-xs leading-relaxed">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-[#FFF8F8] rounded-xl p-6 border border-[#FFE0E0]">
            <h3 className="text-xl font-bold text-[#003366] mb-4 flex items-center gap-2">
              <i className="ri-close-circle-fill text-[#FF6B6B] text-2xl"></i>
              こんな方には向いていないかも
            </h3>
            <div className="space-y-3">
              {notSuitable.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <i className="ri-close-line text-[#FF6B6B] text-lg flex-shrink-0"></i>
                  <p className="text-gray-700 text-sm">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#003366] to-[#0055AA] rounded-xl p-8 text-center text-white">
          <p className="text-lg md:text-xl font-bold mb-2">
            <i className="ri-lightbulb-flash-line mr-2"></i>
            結論
          </p>
          <p className="text-sm md:text-base leading-relaxed">
            最短5分のスピード発行と充実した付帯保険が魅力の地方銀行系スピード発行カード。
            <strong className="text-[#90EE90]">急ぎでカードが必要な方や、旅行保険・スマホ保険を重視する方</strong>には
            非常におすすめできる1枚です。
          </p>
        </div>
      </div>
    </section>
  );
}
